export default __webpack_public_path__ + "static/media/foto3.2bd30ce6.jpg";